// Define default messages for each order status
import { Button } from "antd";

const defaultMessages = {
    INITIE: [
        "La commande des attestations est initiée pour éviter la rupture de stock très proche.",
        "Initialisation de la commande de nouvelles attestations vertes."
    ],
    VALIDE: [
        "Nous validons la commande.",
        "Validation interne de la commande."
    ],
    AUTORISE: [
        "La commande a été autorisée par la société pour traitement ultérieur.",
        "Autorisation de la commande confirmée par la société."
    ],
    RECEPTIONNE: [
        "Le POOL TPVM-VT GIE a réceptionné la commande pour examen.",
        "Commande reçue par le POOL TPVM-VT GIE."
    ],
    EN_TRAITEMENT: [
        "La commande a bien été reçue et est en cours de traitement.",
        "Votre commande est prise en charge."
    ],
    APPROUVE: [
        "La commande est approuvée par le POOL et est en cours de traitement par le POOL.",
        "Commande approuvée par le POOL."
    ],
    REJETE: [
        "Commande rejetée, le stock de lots d'attestations au Pool est insuffisant.",
        "Commande rejetée . Merci de vérifier les détails."
    ],
    CONFIRME: [
        "La commande a été confirmée , en attente de règlement par la société.",
        "Confirmation de la commande enregistrée, en attente de paiement."
    ],
    REGLE: [
        "Le règlement de la commande a été effectué.",
        "La compagnie a procédé au paiement de la commande."
    ],
    DELIVRE: [
        "Le POOL a confirmé la réception du paiement et a procédé à la livraison de la commande.",
        "Paiement reçu par le POOL; la commande a été livrée."
    ],
    CLOTURE: [
        "La commande est clôturée et le processus est terminé.",
        "Processus de commande achevé. La commande est clôturée."
    ],
    default: [
        "Aucun commentaire par défaut disponible pour cette étape."
    ]
};

// Return default messages based on order status
const getDefaultMessages = (statutCommande) => {
    return defaultMessages[statutCommande] || defaultMessages.default;
};

// Component to display clickable default comment suggestions
const DefaultCommentSuggestions = ({ statutCommande, onSelect }) => {
    const messages = getDefaultMessages(statutCommande);
    return (
        <div style={{ marginTop: '8px', display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
            {messages.map((msg, index) => (
                <Button
                    key={index}
                    type="button"
                    onClick={() => onSelect(msg)}
                    style={{
                        padding: '8px 16px',
                        backgroundColor: '#fff',
                        border: '1px solid #e0e0e0',
                        borderRadius: '20px',
                        cursor: 'pointer',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        transition: 'box-shadow 0.3s ease, transform 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.boxShadow = '0 4px 8px rgba(0, 0, 0, 0.2)';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.boxShadow = '0 2px 4px rgba(0, 0, 0, 0.1)';
                        e.currentTarget.style.transform = 'translateY(0)';
                    }}
                >
                    {msg}
                </Button>
            ))}
        </div>
    );
};

export default DefaultCommentSuggestions;